export default __webpack_public_path__ + "static/media/30_thumbnail.eb96ac00.JPG";